import { getSerializedGemstonePageInitialProps } from './getSerializedGemstoneInitialProps'
import type { SerializedGemstonePageType } from '../types'
import { PdpImageCarousel } from '@stuller/stullercom/feat/pdp-image-carousel'
import { Title } from '@stuller/stullercom/feat/layout'
import { SerializedGemstoneSellingInfo } from './SerializedGemstoneSellingInfo'
import {
  useGetSerializedPdpPagesGemstonePermissionsQuery
} from '@stuller/stullercom/data-access/apollo-queries'

/**
 * The Page that will render the content entries with the Content Page content type
 */
const SerializedGemstonePage: SerializedGemstonePageType = ({ serializedGemstone }) => {
  const { data: permissions } = useGetSerializedPdpPagesGemstonePermissionsQuery({
    ssr: true
  })
  const serialNumber = serializedGemstone.serialNumber
  const pageTitle = `${serializedGemstone.geographicalOrigin !== 'Natural' ? serializedGemstone.geographicalOrigin : ''} ${serializedGemstone.stoneFamily} #${serialNumber}`
  const canViewGemstoneRebates = permissions?.viewerPermissions.canViewGemstoneRebates ?? false

  return (
    <div itemScope itemType='https://schema.org/Product'>
      <div className='container-xxxl mw-xxl px-4'>
        <Title>{pageTitle}</Title>
        {pageTitle}
        <div style={{ maxWidth: '500px' }}>
          <PdpImageCarousel item={serializedGemstone} title={pageTitle} />
        </div>
      </div>
      <SerializedGemstoneSellingInfo canViewGemstoneRebate={canViewGemstoneRebates} />
    </div>
  )
}

SerializedGemstonePage.getInitialProps = getSerializedGemstonePageInitialProps

export {
  SerializedGemstonePage
}
